
// CLIENT LOGO RANDOMIZER
const brandList = JSON.parse(vendorData.dataVendor)
let VISIBLE_IMAGE_COUNT = 20
if(brandList.length + 2 < VISIBLE_IMAGE_COUNT) {
    VISIBLE_IMAGE_COUNT = brandList.length - 2
}
const visibleBrandList = []

for (let index = 0; index < VISIBLE_IMAGE_COUNT; index++) {
    visibleBrandList.push(index)
}

const visibleBrandElements = document.querySelectorAll('.about-trustedby__image-container.d-flex');

const randomBrandGallery = (max) => {
    const randomNumber = Math.floor(Math.random() * Math.floor(max));

    if(visibleBrandList.includes(randomNumber)) {
        randomBrandGallery(brandList.length - 1)
    } else {
        const randomIndex = Math.floor(Math.random() * Math.floor(VISIBLE_IMAGE_COUNT-1));
        visibleBrandList.splice(randomIndex, 1, randomNumber)

        visibleBrandElements[randomIndex].classList.add('out');

        setTimeout(() => {
            visibleBrandElements[randomIndex].querySelector('img').src = brandList[randomNumber].partnerImage;
            visibleBrandElements[randomIndex].classList.remove('out');
        }, 500);
        return
    }
};

setInterval(() => {
    randomBrandGallery(brandList.length - 1);
}, 2000);
// CLIENT LOGO RANDOMIZER END